import { RootActions } from 'store/types';
import { actionsHandlers, stateFactories } from 'store/features/utils';
import * as actions from '../actions';
import { createReducer } from '../../../utils';

const stateFactory = stateFactories.createInitialSingleFeatureStateFactory();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const sessionSubscriptionReducer = createReducer<State, Actions>(initialState, {
  [actions.sessionSubscription.request.type]: actionsHandlers.handleSingleFeatureRequest,
  [actions.sessionSubscription.success.type]: actionsHandlers.handleSingleFeatureSuccess,
  [actions.sessionSubscription.failure.type]: actionsHandlers.handleSingleFeatureFailure,
  [actions.sessionSubscription.reset.type]: actionsHandlers.handleSingleFeatureReset,
});

export default sessionSubscriptionReducer;
